import { render, staticRenderFns } from "./setmeal.vue?vue&type=template&id=4300edce&scoped=true&"
import script from "./setmeal.vue?vue&type=script&lang=js&"
export * from "./setmeal.vue?vue&type=script&lang=js&"
import style0 from "./setmeal.vue?vue&type=style&index=0&id=4300edce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4300edce",
  null
  
)

export default component.exports